export const defaultFilters = () => ({
	starts: '',
	ends: '',
	campaignType: '',
	embedOutput: 'all',
	status: '',
	campaignIds: [],
});
export default {
	folders: [],
	campaigns: [],
	archives: 0,
	totalCampaignsCount: 0,
	totalFilteredCampaignsCount: 0,
	draftCount: 0,
	publishCount: 0,
	embedFilter: 'all',
	sort: 'newest',
	filters: defaultFilters(),
	search: '',
	searching: false,
	page: 1,
	bulk: [],
	isSelectAll: false,
	error: false,
};
